import React, { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';
import { FormValidationRules } from '@/models/form/form';

interface Props {
  className?: string;
  rules: FormValidationRules | undefined;
  value?: string | undefined;
  overrideRemaining?: number | undefined;
}

const FormCharacterCount = ({
  className = '',
  rules,
  value = '',
  overrideRemaining = undefined,
}: Props) => {
  const count = useMemo(
    () =>
      typeof overrideRemaining !== 'undefined'
        ? overrideRemaining
        : value?.length,
    [overrideRemaining, value]
  );
  if (!rules || !rules.maxLength) return null;
  return (
    <Typography
      className={twMerge(
        count === rules.maxLength ? 'text-red-utility' : 'text-gray-60',
        'ml-auto',
        className
      )}
      data-testid="characters-remaining"
      variant="caption"
    >
      {`${count}/${rules.maxLength}`}
    </Typography>
  );
};

export default FormCharacterCount;
